var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderRing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 16,
    viewBox: "0 0 35 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8304 4.38214C34.0008 5.24224 33.7465 6.16778 33.0937 7.11826C32.4402 8.06967 31.3985 9.02798 30.0357 9.93487C27.311 11.748 23.346 13.3269 18.7866 14.23C14.2272 15.1332 9.9596 15.1849 6.74954 14.5474C5.1439 14.2285 3.81555 13.7397 2.84873 13.1092C1.88287 12.4794 1.29496 11.7206 1.1246 10.8605C0.954228 10.0004 1.20851 9.0749 1.86135 8.12442C2.51483 7.17301 3.55652 6.2147 4.91936 5.30781C7.64399 3.49472 11.6091 1.91577 16.1685 1.01264C20.7279 0.109509 24.9954 0.0577366 28.2055 0.69528C29.8111 1.01417 31.1395 1.50302 32.1063 2.13349C33.0722 2.76333 33.6601 3.52205 33.8304 4.38214Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderRing);
export default __webpack_public_path__ + "static/media/LoaderRing.181fa4a6.svg";
export { ForwardRef as ReactComponent };